/*
 * Project: BookingEngine
 * Module: components/AlertMessage.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';

import '../static/less/global/alertmessage.less';

import { setAlertMessage } from '../actions/Booking';
import withNavigate from '../withNavigate'; // Importa el HOC

class AlertMessage extends React.Component {
  constructor(props) {
    super(props);
    const countDown = props.returnIn ? props.returnIn : 10;
    this.state = { timeLeft: countDown };
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.props.setTimeout(() => {
      this.onClose();
    }, this.props.returnIn ? this.props.returnIn * 1000 : 10000);

    this.props.setInterval(() => {
      this.setState({ timeLeft: this.state.timeLeft - 1 });
    }, 1000);
  }

  onClose() {
    this.props.dispatch(setAlertMessage(null));
    if (this.props.returnTo) {
      this.props.navigate(this.props.returnTo);
    }
  }

  render() {
    return (
      <div className={`AlertMessage animated slideInDown ${this.props.level}`}
        onClick={this.onClose.bind(this)}
        // eslint-disable-next-line react/no-string-refs
        ref="AlertMessage">
        <i className="fa fa-info-circle"/>
        {this.props.text}
        <span>{this.state.timeLeft}</span>
      </div>
    );
  }
}

AlertMessage.contextTypes = {

};

AlertMessage.propTypes = {
  text: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  returnIn: PropTypes.number,
  returnTo: PropTypes.string,
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

// Envuelve el componente AlertMessage con el HOC withNavigate
const AlertMessageWithNavigate = withNavigate(
  ReactTimeout(connect()(AlertMessage)),
);

export default AlertMessageWithNavigate;
